/* eslint-disable react-refresh/only-export-components */
import { AppLayout } from "@/components/layout/AppLayout";
import { report_definitions } from "@/lib/reports/report-definitions";
import { ReportsToolbar, type ToolbarReportItem } from "./ReportsToolbar";

/**
 * Central report registry used by the Reports toolbar dropdown.
 * Maps every known report to a category for navigation.
 */
export const ALL_REPORTS: ToolbarReportItem[] = [
  ...report_definitions.map((definition) => ({
    id: definition.id,
    reportKey: definition.reportKey,
    name: definition.name,
    category: definition.category,
  })),
  { id: "directory-pdf", reportKey: "directory-pdf", name: "Directory PDF Generator", category: "people" },
  { id: "monthly-summary", reportKey: "monthly-summary", name: "Monthly Board Summary", category: "attendance" },
  { id: "attendance-trends", reportKey: "attendance-trends", name: "Attendance Trends", category: "attendance" },
  { id: "facility-work-orders", reportKey: "facility-work-orders", name: "Facility Work Orders", category: "facilities" },
  { id: "room-usage-summary", reportKey: "room-usage-summary", name: "Room Usage Summary", category: "facilities" },
  { id: "messaging-engagement", reportKey: "messaging-engagement", name: "Messaging Engagement", category: "messaging" },
  { id: "campaign-deliverability", reportKey: "campaign-deliverability", name: "Campaign Deliverability", category: "messaging" },
];

interface ReportsLayoutProps {
  children: React.ReactNode;
  savedViewsSlot?: React.ReactNode;
  scheduleSlot?: React.ReactNode;
  actionSlot?: React.ReactNode;
}

export function ReportsLayout({
  children,
  savedViewsSlot,
  scheduleSlot,
  actionSlot,
}: ReportsLayoutProps) {
  return (
    <AppLayout>
      <div className="flex min-h-0 flex-col">
        <ReportsToolbar
          reports={ALL_REPORTS}
          savedViewsContent={savedViewsSlot}
          scheduleContent={scheduleSlot}
          actionSlot={actionSlot}
        />
        {children}
      </div>
    </AppLayout>
  );
}